import { router, useFocusEffect, usePathname } from 'expo-router';
import { useCallback } from 'react';

import logger from '@fhs-legacy/frontend/src/utils/logger';
import { useMaybeOsActionHandler } from '@fhs-legacy/frontend/src/utils/os-action';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function OsActionPage() {
  const pathname = usePathname();
  const handleMaybeOsAction = useMaybeOsActionHandler();

  useFocusEffect(
    useCallback(() => {
      (async () => {
        logger.info('[os-action] OS ACTION PAGE pathname:' + pathname);
        await handleMaybeOsAction(pathname);
        router.replace(router.canGoBack() ? '../' : '/');
      })();
    }, [handleMaybeOsAction, pathname])
  );

  return null;
}
